import {Component, computed, inject, input} from '@angular/core';

import {IColumnConfig} from '../../../../../types/IColumnConfig';
import {ResultTableService} from '../../../services/result-table.service';
import {IconsComponent} from '../../../../../shared/components/icons/icons.component';
import {FormsModule} from '@angular/forms';
import {PriceResultsHeaderColumn} from './price-results-header-column/price-results-header-column';

@Component({
  selector: 'app-results-table-header-column',
  standalone: true,
  imports: [IconsComponent, FormsModule, PriceResultsHeaderColumn],
  templateUrl: './results-table-header-column.component.html',
  styleUrl: './results-table-header-column.component.css'
})
export class ResultsTableHeaderColumnComponent {
  column = input.required<IColumnConfig>();

  resultsTableService = inject(ResultTableService);

  toggleSort() {
    // @ts-ignore
    this.resultsTableService.toggleSort(this.column().data);
  }

  columnIsSorted = computed(() => this.column().data == this.resultsTableService.sortConfig().field);

  sortDirectionIsAsc = computed(() => this.resultsTableService.sortConfig().direction == 'asc');
}
